module.exports = {
  "/": {},
  "/sales": {},
  "/marketing": {},
  "/service": {},
  "/web-analytics": {},
  "/view": {
    "partialSuccess": {
      "Access denied page loaded": [
        "ACCESS_DENIED_PAGE_LOADED"
      ]
    }
  },
  "/view/:dashboardId": {
    "success": {
      "View dashboard page loaded": [
        "HEADER_LOADED",
        "SUB_HEADER_LOADED",
        "WIDGET_GRID_WRAPPER_LOADED"
      ],
      "View dashboard page empty state loaded": [
        "DASHBOARD_EMPTY_STATE"
      ],
      "View dashboard page not found state loaded": [
        "DASHBOARD_NOT_FOUND"
      ]
    },
    "partialSuccess": {
      "Forbidden access dashboard state loaded": [
        "FORBIDDEN_ACCESS_DASHBOARD"
      ],
      "Access denied page loaded": [
        "ACCESS_DENIED_PAGE_LOADED"
      ]
    },
    "error": [
      "DASHBOARD_LOAD_FAILED"
    ]
  },
  "/view/:dashboardId/:reportId": {
    "success": {
      "Single Report Viewer component loaded": [
        "SRV_LOADED"
      ]
    },
    "error": [
      "DASHBOARD_LOAD_FAILED"
    ]
  },
  "/export/dashboard/:dashboardId": {
    "success": {
      "Export page loaded": [
        "EXPORT_PAGE_LOADED"
      ]
    },
    "error": [
      "EXPORT_PAGE_LOAD_FAILED"
    ]
  },
  "/email-unsubscribe": {
    "name": "emailUnsubscribe",
    "success": {
      "Email unsubscribe page loaded": [
        "EMAIL_UNSUBSCRIBE_PAGE_LOADED"
      ]
    }
  }
};